<template>
  <div>
    <h3>用户管理</h3>

    <!-- 查询区域 -->
    <el-row :gutter="10" style="margin-bottom:15px;">
      <el-col :span="6">
        <el-select v-model="queryAppId" filterable placeholder="选择APP ID" style="width:100%">
          <el-option label="全部APP" value=""></el-option>
          <el-option v-for="item in appList" :key="item.appId" :label="item.appId" :value="item.appId"></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-input v-model="searchPhone" placeholder="搜索手机号"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="getList">查询</el-button>
      </el-col>
      <el-col :span="8">
        <el-button type="success" @click="addShow = true">新增用户</el-button>
      </el-col>
    </el-row>

    <!-- 列表 -->
    <el-table :data="list" border style="width:100%;">
      <el-table-column prop="appId" label="APP ID" />
      <el-table-column prop="phone" label="手机号" />
      <el-table-column prop="nickname" label="昵称" />
      <el-table-column prop="create_time" label="创建时间" />
      <el-table-column label="操作">
        <template #default="{row}">
          <el-button @click="openEdit(row)">修改</el-button>
          <el-button type="danger" @click="del(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      :current-page="pageNum"
      :page-size="pageSize"
      :total="total"
      style="margin-top:20px;text-align:right;"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="getList"
      @current-change="getList"
    />

    <!-- 新增弹窗 -->
    <el-dialog title="新增用户" :visible.sync="addShow" width="500px">
      <el-form :model="form">
        <el-form-item label="选择APP">
          <el-select v-model="form.appId" filterable placeholder="请选择APP" style="width:100%">
            <el-option v-for="item in appList" :key="item.appId" :label="item.appId" :value="item.appId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="form.nickname" placeholder="请输入昵称" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addShow = false">取消</el-button>
        <el-button type="primary" @click="add">确定</el-button>
      </div>
    </el-dialog>

    <!-- 修改弹窗 -->
    <el-dialog title="修改用户" :visible.sync="editShow" width="500px">
      <el-form :model="form">
        <el-form-item label="昵称">
          <el-input v-model="form.nickname" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editShow = false">取消</el-button>
        <el-button type="primary" @click="edit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import req from '@/api/request'
export default {
  data() {
    return {
      appList: [],
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      queryAppId: '',
      searchPhone: '',
      addShow: false,
      editShow: false,
      form: {
        id: '',
        appId: '',
        phone: '',
        nickname: ''
      }
    }
  },
  mounted() {
    this.loadAppList()
    this.getList()
  },
  methods: {
    async loadAppList() {
      const res = await req.get('/admin/app/list')
      this.appList = res.data || []
    },
    async getList() {
      const res = await req.get('/admin/user/list', {
        params: {
          appId: this.queryAppId,
          phone: this.searchPhone,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      })
      this.list = res.data?.list || []
      this.total = res.data?.total || 0
    },
    async add() {
      await req.post('/admin/user/add', this.form)
      this.$message.success('新增成功')
      this.addShow = false
      this.getList()
    },
    openEdit(row) {
      this.form = { ...row }
      this.editShow = true
    },
    async edit() {
      await req.post('/admin/user/edit', this.form)
      this.$message.success('修改成功')
      this.editShow = false
      this.getList()
    },
    async del(id) {
      await req.post('/admin/user/del', { id })
      this.$message.success('删除成功')
      this.getList()
    }
  }
}
</script>